import styled from "styled-components";

export const Root = styled.div`
  min-height: 100vh;
  background: ${(p) => p.theme.tokens.colors.bg};
  padding-bottom: 60px;
`;

export const Content = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 24px 28px 0;
  display: flex;
  align-items: flex-start;
  gap: 28px;
`;

export const ProductColumn = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Section = styled.div`
  scroll-margin-top: 140px;
  margin-bottom: 30px;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 20px 0 14px;
`;

export const SectionIconBadge = styled.span`
  width: 34px;
  height: 34px;
  border-radius: 11px;
  background: ${(p) => p.theme.tokens.colors.softTeal};
  color: ${(p) => p.theme.tokens.colors.teal};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SectionTitle = styled.h2`
  margin: 0;
  font-weight: 900;
  font-size: 21px;
  color: ${(p) => p.theme.tokens.colors.ink};
  letter-spacing: -0.4px;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
`;

export const EmptySearch = styled.div`
  padding: 60px 20px;
  text-align: center;
  color: ${(p) => p.theme.tokens.colors.muted};
  font-size: 14px;
  font-family: ${(p) => p.theme.tokens.font.family};
`;
